import { render } from "./GlanceunionFederation.vue?vue&type=template&id=c21780ba"
import script from "./GlanceunionFederation.vue?vue&type=script&lang=js"
export * from "./GlanceunionFederation.vue?vue&type=script&lang=js"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__